<div class="d-flex align-items-center sub-change-without-login-after__container">
  <span class="sub-change-without-login-after__text" style="font-size: 2rem"
        [innerHTML]="translationService.getTranslation('after_subChange')"> </span>
</div>
